import { createGlobalStyle } from "styled-components";

export const HomeSnapGlobal = createGlobalStyle`
  /* Only when body has the class */
  body.home-snap {
    overflow: hidden;      /* prevent outer scroll */
  }
`;
